import { Controls } from '../../components/Controls';
import { ComparisonContainer } from '../ComparisonContainer';
import { FavoritesControlContainer } from '../FavoritesControlContainer';

export function ControlsContainer() {
  return (
    <Controls>
      <FavoritesControlContainer />
      <ComparisonContainer />
    </Controls>
  );
}
